import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { Grid, Typography } from '@mui/material';
import { DialogDefaultV2, InputV2 } from '../../../components/v2';
import { optionCodeLabel } from '../../../constants/optionCodes';
import { createOption, updateOption } from '../../../helpers/optionApi';

const schema = {
  value: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const emptyValues = { value: '', description: '' };

const Formulario = ({
  open,
  id,
  codigo,
  row,
  onClose,
  onSaved,
  onError,
}) => {
  const [values, setValues] = useState(emptyValues);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const isNew = id === 'novo';

  useEffect(() => {
    if (!open) return;
    if (isNew) {
      setValues(emptyValues);
      setErrors({});
      return;
    }
    setValues({
      value: row?.value || '',
      description: row?.description || '',
    });
    setErrors({});
  }, [open, isNew, row]);

  const handleChange = (event) => {
    setValues((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const onSave = async () => {
    const erros = validate(values, schema);
    setErrors(erros || {});
    if (erros || !codigo) return;

    const payload = {
      codigo,
      value: values.value.trim(),
      description: values.description.trim() || null,
    };

    setSaving(true);
    try {
      if (isNew) await createOption({ ...payload, parentId: null });
      else await updateOption(id, payload);
      onSaved(isNew ? 'Valor criado.' : 'Valor atualizado.');
      onClose(true);
    } catch (error) {
      onError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onClose(false)}
      handlerConfirm={onSave}
      title={isNew ? 'Novo valor' : 'Editar valor'}
      confirmMessage="Salvar"
      maxWidth="sm"
      fullWidth
      confirmLoading={saving}
      confirmLoadingMessage="Salvando…"
      disabledConfirmButton={saving}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" color="text.secondary">
            {optionCodeLabel(codigo)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            error={!!(errors && errors.value)}
            helperText={errors && errors.value ? errors.value[0] : undefined}
            isRequired
            label="Valor"
            name="value"
            onChange={handleChange}
            value={values.value}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Descrição"
            name="description"
            onChange={handleChange}
            value={values.description}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  codigo: PropTypes.string,
  row: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

Formulario.defaultProps = {
  id: null,
  codigo: '',
  row: null,
};

export default Formulario;
